import { useApiClient } from "@/modules/api/apiClient.store.ts";
import { parseClictopayPaymentResult } from "@/modules/billing/clictopay/parseClictopayPaymentResult.ts";
import type { PaymentParams, PaymentProps } from "@/modules/billing/payment/PaymentParams";
import {
    getRedirectUrlFromData,
    linkSendData,
    paymentResultRequest,
    redirectToGatewayAndWaitForResponse,
} from "@/modules/billing/payment/paymentUtils.ts";
import { t_StartingPayment } from "@/modules/billing/progressLabels.tsx";
import { useUnmountSignal } from "@/utils/react/useUnmountSignal.tsx";
import type {
    ClictopayRedirectSendDataResponse,
    MethodConfig,
    ProcessorConfig,
} from "@warrenio/api-spec/spec.oats.gen";
import { useImperativeHandle } from "react";

export type ClictopayLinkProcessorConfig = ProcessorConfig & { type: "link"; keyword: "clictopay" };

export default function ClictopayPaymentForm({
    actionsRef,
    method: { key },
}: {
    config: ClictopayLinkProcessorConfig;
    method: MethodConfig;
} & PaymentProps) {
    //#region Hooks

    const apiClient = useApiClient();
    const signal = useUnmountSignal();

    useImperativeHandle(actionsRef, () => ({
        needsPopUp(_params) {
            return true;
        },

        async makePayment(params: PaymentParams) {
            const { progress, popup, account } = params;

            progress(t_StartingPayment);
            const { data } = await linkSendData<ClictopayRedirectSendDataResponse>(apiClient, params, "clictopay", {
                paymentMethod: key,
            });

            const { persistent_data_ref } = data;

            return await redirectToGatewayAndWaitForResponse({
                popup,
                progress,
                redirectUrl: getRedirectUrlFromData(data),
                signal,
                check: async () =>
                    parseClictopayPaymentResult(
                        await paymentResultRequest(apiClient, account.id, persistent_data_ref, signal),
                    ) != null,
            });
        },
    }));
    //#endregion

    return null;
}
